import { GeneratePromoCodeService } from 'types/services';
import { m8API } from '../m8';
import { normalizeM8Promocode } from '../utils/normalizeM8Promocode';

export const generatePromoCode: GeneratePromoCodeService = async () => {
  const m8PromoCode = await m8API.admin.createPromocode();

  return normalizeM8Promocode(m8PromoCode).toPromocode();
};
